/*
 * @FilePath: throttle.js
 * @Author: Aron
 * @Date: 2023-07-28 17:24:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-28 17:24:14
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
/**
 * 节流原理：在一定时间内，只能触发一次
 *
 * @param {Function} fn 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
export const throttle = (fn, wait = 1000) => {
  let timer = null; // 创建一个标记用来存放定时器的id
  return function() {
    let firstClick = !timer;
    if (timer) {
      clearTimeout(timer);
    }
    // 没有定时器等待执行，则表示可以创建新的定时器来执行函数
    if (firstClick) {
      fn.apply(this, arguments);
    }
    timer = setTimeout(() => {
      // 定时器id清空，表示可以执行下一次调用了
      timer = null;
    }, wait);
  };
};
/**
 *
 * @param {*} money
 * @returns
 * 处理金额千分位
 */
export const money_format = money => {
  if (money !== undefined) {
    const arr = money.toString().split(".");
    return (
      (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
      (arr[1] ? "." + arr[1] : "")
    );
  } else {
    return money;
  }
};
export default { throttle, money_format };
